/**
 * Sistem rol ID'leri (backend t_rol tablosu ile birebir).
 * Environment'tan bağımsız sabit değerlerdir; bu yüzden kod-enums.config.ts'teki
 * environment'a bağlı kod ID'lerinden ayrı, tek bir merkezde tutulur.
 *
 * Kullanım:
 *   import { ROLE } from 'src/app/core/config/role-enums.config';
 *   if (r.rolId === ROLE.GundemGoruntuleyici) { ... }
 */
export enum ROLE {
  SuperAdmin = 1,
  Admin = 2,
  YeniKullanici = 7,
  PatentDegerlendirmeYetkilisi = 10,
  /** Kod Yönetim Genel (CRUD) Rolü */
  KodYonetimGenel = 11,
  /** Kod Yönetim Silinebilirlik İşlemleri Rolü */
  KodYonetimSilinebilirlik = 12,
  /** Kod Yönetim Aktiflik İşlemleri Rolü */
  KodYonetimAktiflik = 13,
  /** Başvuru Zorunluluk Kontrollerine Takılmasın Rolü */
  BasvuruZorunlulukKontrolleriniAtla = 14,
  /** Soru Yönetimi Genel Rolü */
  SoruYonetimiGenel = 15,
  /** Soru Yönetimi Soru Aktifleştirme Rolü */
  SoruYonetimiAktiflestirme = 16,
  /** İşlem Yapan Buluşçulara Bildirim Yapmaz */
  BuscularaBildirimYapmaz = 17,
  FirmaYoneticisi = 18,
  FirmaKullanicisi = 19,
  /** Gündem Düzenleyici - Başkan (t_gundem_uye.RoleTipId olarak da kullanılır) */
  GundemDuzenleyiciBaskan = 20,
  /** Gündem Görüntüleyici / Üye (t_gundem_uye.RoleTipId olarak da kullanılır) */
  GundemGoruntuleyici = 21,
  /** Gündem Düzenleyici - Sekreter (t_gundem_uye.RoleTipId olarak da kullanılır) */
  GundemDuzenleyiciSekreter = 22,
}

/** Gündem'e özgü rol ID'leri (Başkan / Görüntüleyici / Sekreter). */
export const GUNDEM_ROL_IDLERI: readonly number[] = [
  ROLE.GundemDuzenleyiciBaskan,
  ROLE.GundemGoruntuleyici,
  ROLE.GundemDuzenleyiciSekreter,
];
